import React, { useState,useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { httpRequest } from 'utils/httpRequest';
import { toast } from 'react-toastify';
import CircleLoader from "components/loader/CircleLoader"
import { useLoader } from 'components/loader/useLoader';
import ErrorComponent from 'components/error/ErrorComponent';

const UserManagement = () => {

    const { loading, startLoading, stopLoading } = useLoader()
    // Sample data - you can replace this with your dynamic data
    const [data, setData] = useState([
        { id: 1, name: 'John Doe', email: 'john@example.com', },
        { id: 2, name: 'Jane Smith', email: 'jane@example.com', },
        { id: 3, name: 'Mike Johnson', email: 'mike@example.com', },
        { id: 4, name: 'Sarah Wilson', email: 'sarah@example.com', },
        { id: 5, name: 'Tom Brown', email: 'tom@example.com', },
        { id: 6, name: 'Lisa Davis', email: 'lisa@example.com', },
        { id: 7, name: 'Mark Taylor', email: 'mark@example.com', },
    ]);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [usersData,setUsersData]=useState([])
    const [error,setError]=useState(false)
    const itemsPerPage = 3;

    // Calculate pagination
    



    const handleDelete = async(userId) => {
        try {
        
                    const response = await httpRequest(
                        `admin/deleteUser/${userId}`,
                        "DELETE",
                        {},
                        {},
                        true,
                        false
                    );
        
                    if (response?.code === 200) {
                        toast.success("User deleted successfully.")
                        fetchUsersData()
                        // const newTotal = total - 1;
                        // const maxPages = Math.ceil(newTotal / limit);
                        // const newPage = activePage > maxPages ? maxPages : activePage;
        
                        // setTotal(newTotal); // optional
                        // setActivePage(newPage);
                        // fetchAdditionalResourceData(newPage, limit)
        
                    }
        
                } catch (error) {
                    console.log(error);
                  
                }
    };

    const handleEdit = (userId) => {
        navigate(`/admin/edit-user/${userId}`)
    };




    const handleNavigationOnAddUser = () => {
        navigate("/admin/add-user")
    }



const fetchUsersData=async ()=>{
    startLoading()
    try {
    
       const response = await httpRequest(
                    "admin/getUsers",
                    "GET",
                    {},
                    {
                        // page: page,
                        // limit: limit
                    },
                    true,
                    false
                );
                if (response?.code === 200) {
                   
                    setUsersData(response?.data)
                    // setTotal(response?.total);
                    // setActivePage(response?.page);
                    // setLimit(response?.limit);
                }
            } catch (error) {
                console.log("Upload error:", error);
                setError(true)
                // throw error;
            }finally{
                stopLoading()
            }
}

useEffect(()=>{
    fetchUsersData()
},[])


const handleRetry = () => {
    setError(false);
    // Your retry logic here
    fetchUsersData();
  };


    return (
        <>


      {loading ? <CircleLoader/> : error ? <ErrorComponent onRetry={handleRetry} />: (     <div className="container-fluid py-4 mt-5">
                <div className="row">
                    <div className="col">
                        <div className="card shadow">
                            {/* Card Header */}
                            <div className="card-header border-0 d-flex justify-content-end">
                                <h3 className="mb-0 mr-auto">User Management</h3>
                                <Button color="primary" size="sm" onClick={handleNavigationOnAddUser}>
                                    Add User
                                </Button>
                            </div>

                            {/* Table */}
                            <div className="table-responsive">
                                <table className="table align-items-center table-flush">
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">S.No</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Email</th>
                                            <th scope="col">Action</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {usersData && usersData.length>0 && usersData.map((item, index) => (
                                            <tr key={item?._id}>

                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                        {index + 1}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                        {item?.firstName}
                                                    </span>{" "}
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                        { item?.lastName}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="text-muted">
                                                        {item?.email}
                                                    </span>
                                                </td>

                                                <td>
                                                    <button
                                                        className="btn  btn-sm"
                                                        onClick={() => handleEdit(item._id)}
                                                      
                                                        title="Edit"
                                                    >
                                                       <i className="fas fa-edit text-primary me-2" title="Edit"></i>
                                                    </button>
                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(item._id)}
                                                        title="Delete"
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Card Footer with Pagination */}
                            <div className="card-footer py-4">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>)}



        </>
    );
};

export default UserManagement;